<template>
<v-app>

    <Drawer current_item="menu_special_market_setting"></Drawer>

    <v-dialog v-model="dialog_add_product" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>ระบุชื่อ Product</v-card-title>
          <v-card-text>
            <v-text-field v-model="new_product_name" outlined hide-details class="mt-4"></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="addProduct">{{ $t('form_submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    <v-dialog v-model="dialog_order_limit" max-width="600" >
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>เพิ่ม Order Limit ให้ : {{ tmp_product_id ? product_list.filter(p=>p.product_id == tmp_product_id)[0].product_name : "" }}</v-card-title>
          <v-card-text>
            <v-text-field
                class="mt-4"
                v-model="new_order_limit"
                outlined
                dense
                hide-details
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mt-2" @click="update_orderlimit" style="color:white" rounded color="green">
                ยืนยันการเพิ่ม orderlimit
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>


    <v-main class="ml-6 mr-6" v-if="permission.includes('VIEW_specialmarketsetting')">

        <v-row align="end" justify="space-between">
            <v-col cols="8" class="text-md-h4 text-h5" align="left">
                Special Market Setting
            </v-col>
            <v-col cols="4" align="right" class="pr-8">
                <v-btn v-if="permission.includes('CREATE_specialmarketsetting')" tile color="success" @click="dialog_add_product = true">
                    <v-icon left>mdi-plus</v-icon> ADD PRODUCT
                </v-btn>
            </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-list align="left">
            <v-list-item
                v-for="(item) in product_list"
                :key="item.product_id"
            >
                <v-card class="pa-4 mt-4" width="100%">
                    Product Name : {{item.product_name}}
                    <v-row>
                        <v-col  cols="5"  class="text-center">
                            <h5 class="green--text">Order Limit : {{item.order_count}}/{{item.order_limit}}</h5>
                            <v-progress-linear
                                    v-model="item.order_percentage"
                                    height="25"
                                    striped
                                >
                                <h6>{{ item.order_percentage }}% </h6>
                            </v-progress-linear>
                        </v-col> 
                        <v-col cols="2">
                            <v-btn @click="open_dialog_order_limit(item.product_id)" style="color:white" rounded color="orange">
                                เพิ่ม orderlimit
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-btn class="mt-2" @click="update_price(item.product_id)" style="color:white" rounded color="green" :disabled="!is_new_price[item.product_id]">
                        ยืนยันจำนวนชิ้นและราคาใหม่
                    </v-btn>
                        <v-simple-table fixed-header align="left" >
                            <template v-slot:default>
                            <thead>
                                <tr>
                                <th class="text-left">ชื่อตัวเลือก</th>
                                <th class="text-left">จำนวนชิ้นที่ตัด stock</th>
                                <th class="text-left">ค่าสินค้า</th>
                                <th class="text-left">ค่าขนส่ง</th>
                                <th class="text-left"><v-btn tile icon @click="add_price(item.product_id)" >
                                <v-icon>mdi-plus</v-icon>
                            </v-btn></th>
                                </tr>
                            </thead>
                            <tbody >
                                <tr v-for="(p,i) in price[item.product_id]" :key="'price_' + item.product_id + '_' + i"> 
                                    <td>
                                        <v-text-field
                                            v-model="p.item_name"
                                            @change="(val) => {price[item.product_id][i].item_name = val;change_price(item.product_id);}"
                                            outlined
                                            dense
                                            hide-details
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="p.item_piece"
                                            @change="(val) => {price[item.product_id][i].item_piece = val;change_price(item.product_id);}"
                                            outlined
                                            dense
                                            hide-details
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="p.item_price"
                                            @change="(val) => {price[item.product_id][i].item_price = val;change_price(item.product_id);}"
                                            outlined
                                            dense
                                            hide-details
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="p.item_fee"
                                            @change="(val) => {price[item.product_id][i].item_fee = val;change_price(item.product_id);}"
                                            outlined
                                            dense
                                            hide-details
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-btn tile icon @click="del_price(item.product_id,i)">
                                            <v-icon>mdi-trash-can</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    
                </v-card>
            </v-list-item>
        </v-list>

        <v-divider class="mb-6"></v-divider>

    </v-main>
</v-app>
</template>

<script>
import Drawer from '@/components/Drawer.vue'

import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

export default {
    components: {
        Drawer
    },
    data () {
        return {
            permission : []

            ,tmp_product_id : 0

            ,product_list : []

            ,dialog_add_product : false
            ,new_product_name : ""

            ,dialog_order_limit : false
            ,new_order_limit : 0

            ,is_new_price : {}
            ,price : {}
            ,old_price : {}
        }
    },
    mounted : function () {
        var que = this.$store.commit('addLoading')
        this.permission = Staff.getPermission('SpecialMarket').then(permission=>{
            this.$store.commit('finishLoading',que)
            this.permission = permission
            if(this.permission.includes('VIEW_specialmarketsetting')){
                this.reload()
            }
        })
    },
    methods : {
        reload(){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.specialmarket.get_setting
                ,{}
                ,{ headers: Staff.getTokenHeader()}
            ).then(response => {
                this.$store.commit('finishLoading',que)
                this.product_list = response.data.product
                console.log(response.data)
                this.product_list.forEach((p,i,arr)=>{
                    
                    arr[i]['order_percentage'] = (p.order_count*100/p.order_limit).toFixed(2)
                    this.is_new_price[p.product_id]  = false
                    this.price[p.product_id] = response.data.price.filter(price=>price.product_id == p.product_id)
                    this.old_price[p.product_id] = []
                    this.price[p.product_id].forEach(e=>{
                        this.old_price[p.product_id].push({
                            item_name : e.item_name
                            ,item_piece : e.item_piece
                            ,item_price : e.item_price
                            ,item_fee : e.item_fee
                        })
                    })
                })
            })
        },
        addProduct(){
            this.dialog_add_product = false
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.specialmarket.add_product
                ,{product_name:this.new_product_name}
                ,{ headers: Staff.getTokenHeader()}
            ).then(() => {
                this.$store.commit('finishLoading',que)
                this.new_product_name = ""
                this.reload()
            })
        },
        open_dialog_order_limit(product_id){
            this.tmp_product_id = product_id
            this.dialog_order_limit = true;
            this.new_order_limit = this.product_list.filter(p=>p.product_id == product_id)[0].order_limit
        },
        update_orderlimit(){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.specialmarket.update_orderlimit
                ,{ 
                    product_id:this.tmp_product_id 
                    ,order_limit:this.new_order_limit 
                }
                ,{ headers: Staff.getTokenHeader()}
            ).then(() => {
                this.$store.commit('finishLoading',que)
                this.dialog_order_limit = false
                this.reload()
            })
        },
        update_price(product_id){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.specialmarket.update_price
                ,{ 
                    product_id:product_id
                    ,price:this.price[product_id] 
                }
                ,{ headers: Staff.getTokenHeader()}
            ).then(() => {
                this.$store.commit('finishLoading',que)
                this.reload()
            })
        },
        add_price(product_id){
            this.price[product_id].push({
                item_name:""
                ,item_piece:""
                ,item_price:""
                ,item_fee:""
            })
            this.change_price(product_id)
        },
        del_price(product_id,i){
            this.price[product_id].splice(i,1)
            this.change_price(product_id)
        },
        change_price(product_id){
          var result = false
          if(this.price[product_id].length != this.old_price[product_id].length){
              result = true;
          }else{
              var newpricelist = this.price[product_id]
              this.old_price[product_id].forEach((v,i)=>{
                  if(newpricelist[i].item_name!=v.item_name 
                    || newpricelist[i].item_piece!=v.item_piece
                    || newpricelist[i].item_price!=v.item_price
                    || newpricelist[i].item_fee!=v.item_fee
                  ){
                    result = true;
                  }
              })
          }
          this.is_new_price[product_id] = result;
          this.$forceUpdate();
        }
    }
}
</script>